import { render } from "./InfoBox.vue?vue&type=template&id=7dc7c90c&scoped=true"
import script from "./InfoBox.vue?vue&type=script&lang=js"
export * from "./InfoBox.vue?vue&type=script&lang=js"

import "./InfoBox.vue?vue&type=style&index=0&id=7dc7c90c&scoped=true&lang=css"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc7c90c"]])

export default __exports__